// extracted by mini-css-extract-plugin
export default {"header":"device-manage-link_header__uEFnd","title":"device-manage-link_title__eJZo5","section":"device-manage-link_section__JWcP0"};